import Vue from 'vue'
import VueRouter from 'vue-router'
import { Message } from 'element-ui'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/',
    // 根路径默认重定向到dashboard，路由守卫会根据token情况处理
    redirect: '/login'
  },

  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue')
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('@/views/Users.vue')
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/Settings.vue')
  },
  {
    path: '/log-query',
    name: 'LogQuery',
    component: () => import('@/views/LogQuery.vue')
  },
  {
    path: '/customers',
    name: 'Customers',
    component: () => import('@/views/Customers.vue')
  },
  {
    path: '/customer-pool',
    name: 'CustomerPool',
    component: () => import('@/views/CustomerPool.vue')
  },
  {
    path: '/invalid-customer-pool',
    name: 'InvalidCustomerPool',
    component: () => import('@/views/InvalidCustomerPool.vue')
  },
  {
    path: '/my-customers',
    name: 'MyCustomers',
    component: () => import('@/views/MyCustomers.vue')
  },
  {
    path: '/transaction-management',
    name: 'TransactionManagement',
    component: () => import('@/views/TransactionManagement.vue')
  },
  {
    path: '/suppliers',
    name: 'Suppliers',
    component: () => import('@/views/Suppliers.vue')
  },
  { path: '/financial-reconciliation', name: 'FinancialReconciliation', component: () => import('@/views/FinancialReconciliation.vue') },
  { path: '/admin-file-pool', name: 'AdminFilePool', component: () => import('@/views/FilePool/AdminFilePool.vue') },
  { path: '/my-file-pool', name: 'MyFilePool', component: () => import('@/views/FilePool/MyFilePool.vue') }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 获取token
  const token = localStorage.getItem('token')



  // 如果访问的是登录页面，直接放行
  if (to.path === '/login') {
    console.log('Accessing login page, allowing')
    next()
    return
  }

  // 如果没有token，重定向到登录页面
  if (!token) {
    console.log('No token, redirecting to login')
    next('/login')
    return
  }

  // 检查是否是管理员，并且尝试访问管理员页面
  if (to.path === '/users' || to.path === '/admin-file-pool') {
    const employeeStr = localStorage.getItem('employee')
    if (employeeStr) {
      try {
        const employee = JSON.parse(employeeStr)
        if (employee.role !== 'admin') {
          console.log('Non-admin user trying to access admin page, redirecting to dashboard')
          Message.error('您没有权限访问该页面')
          next('/dashboard')
          return
        }
      } catch (e) {
        console.error('解析员工信息失败:', e)
        Message.error('权限验证失败')
        next('/dashboard')
        return
      }
    } else {
      console.log('No employee info, redirecting to dashboard')
      Message.error('请先登录')
      next('/login')
      return
    }
  }

  // 有token且权限符合，放行
  console.log('Has token and permission, allowing access')
  next()
})

export default router